export default __webpack_public_path__ + "media/titles/title_1_locale_tr-120c0d76.png";